import React, { createContext, useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom"; 
import { getData } from "../fetchRoutes/getData";

export const SearchAndFilterContext = createContext();

export default function SearchAndFilterProvider(props) {
    const filterUrl = process.env.REACT_APP_FILTER_PROPERTIES;
    const [searchParams, setSearchParams] = useSearchParams();

    // Function to get filters from URL OR localStorage
    const getStoredFilters = () => {
        const savedFilters = JSON.parse(localStorage.getItem("propertyFilters")) || {};
        return {
            beds: searchParams.get("beds") || savedFilters.beds || "",
            price: searchParams.get("price") || savedFilters.price || "",
            auctionStatus: searchParams.get("auctionStatus") || savedFilters.auctionStatus || "",
            reservePrice: searchParams.get("reservePrice") || savedFilters.reservePrice || "",
        };
    };

    const [searchQuery, setSearchQuery] = useState(searchParams.get("location") || localStorage.getItem("searchQuery") || "");
    const [filterQueries, setFilterQueries] = useState(getStoredFilters);
    const [filter, setFilter] = useState(false);

    // Save to localStorage when filters change
    useEffect(() => {
        localStorage.setItem("searchQuery", searchQuery);
        localStorage.setItem("propertyFilters", JSON.stringify(filterQueries));

        setSearchParams((prevParams) => {
            const params = new URLSearchParams(prevParams);

            if (searchQuery) params.set("location", searchQuery);
            else params.delete("location");

            Object.entries(filterQueries).forEach(([key, value]) => {
                if (value) params.set(key, value);
                else params.delete(key);
            });

            return params;
        });
    }, [searchQuery, filterQueries, setSearchParams]);

    // Load from localStorage when component mounts
    useEffect(() => {
        const savedQuery = localStorage.getItem("searchQuery") || "";
        const savedFilters = JSON.parse(localStorage.getItem("propertyFilters")) || {};

        setSearchQuery(savedQuery);
        setFilterQueries(savedFilters);
    }, []); // Runs only once on mount

    const handleChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleFilterChange = (event) => {
        setFilterQueries((prev) => ({ ...prev, [event.target.name]: event.target.value }));
    };

    const handleFilteration = async (setFilteredProperties) => {
        setFilter(true);
        const queryString = searchParams.toString() ? `?${searchParams.toString()}` : "";

        try {
            const response = await getData(`${filterUrl}${queryString}`);
            if (response.status === "success") {
                setFilteredProperties(response.data);
            } else {
                console.error("Error fetching properties:", response.message);
                setFilteredProperties([]);
            }
        } catch (error) {
            console.error("Network error:", error);
            setFilteredProperties([]);
        } finally {
            setFilter(false);
        }
    };

    // Reset filters and clear localStorage
    const handleReset = (setFilteredProperties, properties) => {
        setSearchQuery("");
        setFilterQueries({ beds: "", price: "", auctionStatus: "", reservePrice: "" });
        setSearchParams(new URLSearchParams()); // Clear the URL
        localStorage.removeItem("searchQuery");
        localStorage.removeItem("propertyFilters");
        setFilteredProperties(properties);
    };

    return (
        <SearchAndFilterContext.Provider
            value={{
                searchQuery,
                setSearchQuery,
                filterQueries,
                setFilterQueries,
                handleChange,
                handleFilterChange,
                handleFilteration,
                handleReset,
                filter,
                setFilter,
            }}
        >
            {props.children}
        </SearchAndFilterContext.Provider>
    );
}

